//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from "@/config";
import { required, minLength, maxLength, alphaNum } from "vuelidate/lib/validators";

export default {
  components: {
  },
  data: function() {
    return {
      username: "",
      password: "",
      isPwd: true,
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/"
    };
  },
  validations: {
    username: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20),
      alphaNum
    },
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(20)
    }
  },
  computed: {
    app() {
      return {
        title: config.appTitle,
        version: config.appVersion
      };
    }
  },
  mounted: function() {
    const url = this.$route.query.redirect;
    if (url) {
      this.redirect = url;
    }
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
    },
    login: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let username = this.username;
        let password = this.password;
        this.loading = true;
        this.$store
          .dispatch("user/login", { username, password })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.status;
            if (this.submission.success == true) {
              this.$router.push(this.redirect);
            } else {
              this.loading = false;
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
